import {TextField} from '@mui/material';
import {DateObject} from 'react-multi-date-picker';
import {LocalizedDatePicker as DatePicker} from '../common/dates/LocalizedCalendar';
import {AppTranslationFunction} from '@mybake/ui/hooks/useAppTranslation';

interface Props {
    label: string;
    value: string;
    error: boolean;
    helperText?: string;
    onChange: (value: string) => void;
    t: AppTranslationFunction;
}

export const FinanceDateField = ({label, value, error, helperText, onChange}: Props) => {
    return (
        <DatePicker
            value={value}
            format="DD-MM-YYYY"
            minDate={new Date(1900, 0, 1)}
            maxDate={new Date(2100, 11, 31)}
            weekStartDayIndex={1}
            calendarPosition="bottom-start"
            containerStyle={{width: '100%'}}
            onChange={(selectedDate) => {
                const date = Array.isArray(selectedDate) ? selectedDate[0] : selectedDate;
                if (date instanceof DateObject) onChange(date.format('DD-MM-YYYY'));
            }}
            render={(_, openCalendar, handleValueChange) => (
                <TextField
                    fullWidth
                    label={label}
                    value={value}
                    error={error}
                    helperText={helperText}
                    placeholder="DD-MM-YYYY"
                    inputProps={{maxLength: 10, inputMode: 'numeric'}}
                    InputLabelProps={{shrink: true}}
                    onClick={openCalendar}
                    onChange={(event) => {
                        onChange(event.target.value);
                        handleValueChange(event);
                    }}
                />
            )}
        />
    );
};
